import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonHttpService } from '@app/core/services/common-http.service';
import { PaginationModel } from '@app/models/query-models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LeavesService {

  private readonly baseRoute = 'solodriver/get-leave-request';
  
  constructor(
    private commonHttpService: CommonHttpService,
  ) {}

  /**
   * Fetch all Owner Operator leaves
   * @param status Optional status filter
  */
 
 
public getAllOwnerOperatoLeaves(
  status?: number,
  argPaginationModel: PaginationModel = null
): Observable<any> {
  if (!argPaginationModel) {
    argPaginationModel = new PaginationModel();
  }

  let params = new HttpParams()
    .set('pageNumber', `${argPaginationModel.pageNumber || 1}`)
    .set('pageSize', `${argPaginationModel.recordCount || 10}`);

  if (status !== undefined && status !== null && status > 0) {
    params = params.set('status', `${status}`);
  }
  if (argPaginationModel?.sortBy) {
    params = params.set('sortBy', argPaginationModel.sortBy);
  }
  if (argPaginationModel?.orderBy) {
    params = params.set('orderBy', argPaginationModel.orderBy);
  }

  return this.commonHttpService.get<any>(this.baseRoute, params);
}

public updateLeave(leaveId: number, dto: any): Observable<any> {
  return this.commonHttpService.patch<any, any>(`solodriver/update-leave-request/${leaveId}`, dto);
}

public approveLeave(leaveId: number): Observable<any> {
  return this.commonHttpService.patch<any, any>(`solodriver/approve-leave-request/${leaveId}`, {});
}

public cancelLeave(leaveId: number): Observable<any> {
  return this.commonHttpService.patch<any, any>(`solodriver/cancel-leave-request/${leaveId}`, {});
}

}
